import React, { useContext, useEffect, useState } from "react";
import { RoundButton, RoundButtonDiv } from "@components/Buttons";
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { FaSignature } from "react-icons/fa";
import { ButtonSecondary } from "@components/Buttons";
import axios from "axios";
import { SIGNATURE_PAYMENTS_BASE_URL } from "@constants/constants";
import MixPanel from "@utils/mixpanel";
import FB from "../../../utils/tracking/facebook";
import Link from "next/link";
import {
  createCheckoutURL,
  createUTMQueryParams,
  is1DollarTrialCampaign,
} from "@utils/signature_owner";
import AppContext from "components/AppContext";
import { Button1 } from "@components/google-ads/Buttons";
import {
  CLMButtonPrimary1,
  CLMButtonSecondaryBorder,
  CLMSecondaryBorder,
} from "components/CLM/v3/Buttons";

const PricingCardV3 = ({
  title,
  description,
  price,
  priceDetail,
  pricingType,
  pricingTag,
  featuresIcon,
  featuresTitle,
  features,
  pricingLink,
  bgColor,
  quantityName,
  recommended,
  cardBorder = false,
  buttonText,
  buttonUrl,
  transparent = true,
  buttonSecondaryText,
  buttonSecondaryUrl,
  trialButtonText,
  trialButtonUrl,
  isAnnualBilling,
  owner,
  contactUs,
  setImagePopup,
  additionalSeatPrice,
  noCreditCard,
  setRegisterPopup,
  packagesCount,
  conditions = {
    navigateRegister: false,
    navigateCheckout: false,
  },
  setShowCalcomModal,
}) => {
  const context = useContext(AppContext);
  const [quantity, setQuantity] = useState(1);
  const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] =
    useState(false);

  const handleQuantity = (type) => {
    if (type === "add") {
      setQuantity(quantity + 1);
    } else {
      if (quantity > 1) {
        setQuantity(quantity - 1);
      }
    }
  };

  const PRICE_IDS = {
    Freelancer: {
      monthly: "price_1OUqsgLiGbRu8waGk8eObdee",
      annually: "price_1Pm6c8LiGbRu8waGnOLvuz9X",
    },
    Team: {
      monthly: "price_1Prwz6LiGbRu8waGHZVC9vlT",
      annually: "price_1PryxwLiGbRu8waGJRAgEtfv",
    },
    "Growing Business": {
      monthly: "price_1PrwyWLiGbRu8waG4z6iibAA",
      annually: "price_1PryznLiGbRu8waGelr3LUcb",
    },
    API: {
      // no annually for api
      priceIdBase: "price_1PYojRLiGbRu8waGVLQYGY9Q",
      priceIdUsage: "price_1PYokyLiGbRu8waGlZU5MzpM",
    },
  };

  let createStripeSubscriptionAPI = async (title) => {
    try {
      // let priceId;
      // const durationKey = isAnnualBilling ? "annually" : "monthly";
      // priceId = PRICE_IDS?.[title]?.[durationKey];
      // if (!priceId)
      //   window.location.href = `https://signature.boloforms.com/register?from=WEBSITE_PRICING_BUTTON`;
      // let quantity = title === "Freelancer" ? 1 : count;
      // let quantity = quantity;
      let { data } = await axios.post(
        `${SIGNATURE_PAYMENTS_BASE_URL}/createAPISubscriptionUS`,
        {
          priceId: PRICE_IDS[title].priceIdBase,
          meteredPriceId: PRICE_IDS[title].priceIdUsage,
          ownerEmail: owner?.email,
          cancelUrl: window.location.href,
          successUrl: `https://www.boloforms.com/thank-you?value=${
            price * quantity
          }&priceId=${PRICE_IDS[title].priceIdBase}&priceIdUsage=${
            PRICE_IDS[title].priceIdUsage
          }&qunatity=${quantity}&plan=${title}`,
        }
      );
      let { sessionUrl } = data;

      // facebook tracking
      new FB().trackInitiateCheckout(
        title,
        PRICE_IDS[title].priceIdBase,
        quantity,
        isAnnualBilling ? 12 * price * quantity : price * quantity
      );

      // mixpanel tracking
      new MixPanel().track("Billing", {
        billing_action: "billing_click_subscribe",
        plan: title,
        pack: quantity,
        planCycle: isAnnualBilling ? "Annually" : "Monthly",
        amount: isAnnualBilling ? 12 * price * quantity : price * quantity,
      });
      new MixPanel().increment("billing_click_subscribe");

      window.open(sessionUrl, "_self");
    } catch (error) {
      console.error(error);
    }
  };

  let createStripeSubscription = async (title) => {
    if (title === "API") {
      createStripeSubscriptionAPI(title);
      return;
    }

    try {
      let priceId;
      const durationKey = isAnnualBilling ? "annually" : "monthly";
      priceId = PRICE_IDS?.[title]?.[durationKey];
      if (!priceId)
        window.location.href = `https://signature.boloforms.com/register?from=WEBSITE_PRICING_BUTTON${createUTMQueryParams(
          {
            from: "WEBSITE_PRICING_BUTTON",
          }
        )}`;

      if (conditions?.navigateCheckout) {
        let checkoutUrl = createCheckoutURL({
          priceId: priceId,
          quantity: quantity,
          value: price,
          product: title,
          cycle: isAnnualBilling ? "annually" : "monthly",
        });
        window.open(checkoutUrl, "_self");
      } else {
        // let quantity = title === "Freelancer" ? 1 : count;
        // let quantity = quantity;
        let { data } = await axios.post(
          `${SIGNATURE_PAYMENTS_BASE_URL}/createStripeSubscriptionUS`,
          {
            priceId: priceId,
            quantity: quantity,
            ownerEmail: owner?.email,
            cancelUrl: window.location.href,
            successUrl: `https://www.boloforms.com/thank-you?value=${
              price * quantity
            }&priceId=${priceId}&qunatity=${quantity}&plan=${title}`,
          }
        );
        let { sessionUrl } = data;

        // facebook tracking
        new FB().trackInitiateCheckout(
          title,
          priceId,
          quantity,
          isAnnualBilling ? 12 * price * quantity : price * quantity
        );

        // mixpanel tracking
        new MixPanel().track("Billing", {
          billing_action: "billing_click_subscribe",
          plan: title,
          pack: quantity,
          planCycle: isAnnualBilling ? "Annually" : "Monthly",
          amount: isAnnualBilling ? 12 * price * quantity : price * quantity,
        });
        new MixPanel().increment("billing_click_subscribe");

        window.open(sessionUrl, "_self");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setIs1DollarTrialCampaignState(
      is1DollarTrialCampaign({
        utm_campaign: context?.globalData?.utmData?.utm_campaign,
      })
    );
  }, [context?.globalData?.utmData?.utm_campaign]);

  return (
    <>
      {/* <div className="h-14 text-xl font-semibold flex items-center justify-center text-white">
        {recommended && "Most Popular"}
      </div> */}
      <div
        className={`h-full md:rounded-3xl rounded-xl  flex flex-col gap-10 justify-between items-center  bg-white border-[2px] border-slate-200 relative ${
          recommended ? "" : ""
        }`}
      >
        {recommended && (
          <div className="absolute top-0 right-0 w-1/2 md:h-12 h-9 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 flex items-center justify-center md:rounded-bl-3xl md:rounded-tr-3xl rounded-tr-xl rounded-bl-xl text-white md:text-[18px] text-smfont-medium">
            Most Popular
          </div>
        )}
        <div className="w-full space-y-6">
          <div
            className={`border-b-2 border-b-slate-200 md:p-6 p-4 flex justify-start items-start flex-col min-h-[280px] `}
          >
            <h2 className="text-3xl font-bold">{title}</h2>
            <p className="text-[15px] text-left text-gray-600 mt-4 min-h-[60px] ">
              {description}
            </p>
            <div>
              {typeof price === "number" ? (
                <div className="space-y-2">
                  <div className="flex justify-center items-end">
                    <p className="text-5xl font-bold">
                      <span className="text-3xl mr-1">$</span>
                      {title === "Growing Business"
                        ? price + additionalSeatPrice * (quantity - 1)
                        : price * quantity}
                    </p>
                    <p className="text-xl">{packagesCount || "/mo"}</p>
                    {/* <p className="text-xl">{priceDetail || ""}</p> */}
                  </div>

                  <p className="text-left text-base text-gray-600">
                    {pricingType === "One-time"
                      ? "One-time"
                      : pricingType === "mo"
                      ? "Billed monthly"
                      : "Billed Annually"}
                  </p>
                </div>
              ) : (
                <div className="w-full flex flex-col gap-2">
                  <p className="text-base text-left min-h-[81px] font-semibold">
                    {price}
                  </p>
                </div>
              )}
            </div>

            {pricingTag && (
              <p className="text-lg flex items-center justify-start gap-2 font-semibold mt-3 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent">
                <FaSignature className="text-xl text-purple-500" />
                {typeof pricingTag == "number"
                  ? `${pricingTag * quantity} Form Signatures/Mo`
                  : `${pricingTag} Form Signatures`}
              </p>
            )}
          </div>

          {/* <div className="w-full flex flex-col gap-4 px-6">
            <div className={`md:min-h-[32px]`}>
              {quantityName && (
                <div className="flex items-center justify-center">
                  <button
                    onClick={() => handleQuantity("remove")}
                    className={`w-10 h-8 bg-transparent text-black border border-black grid place-items-center rounded-l outline-none ${
                      quantity === 1
                        ? "cursor-not-allowed"
                        : "cursor-pointer hover:bg-black hover:text-white"
                    }`}
                  >
                    <FaMinus />
                  </button>
                  <div className="h-8 box-border border-y border-black px-2 text-sm grid place-items-center">
                    {quantity} {quantityName}
                  </div>
                  <button
                    onClick={() => handleQuantity("add")}
                    className={`w-10 h-8 bg-transparent text-black border border-black grid place-items-center rounded-r cursor-pointer hover:bg-black hover:text-white outline-none`}
                  >
                    <FaPlus />
                  </button>
                </div>
              )}
            </div>
          </div> */}

          <div className="w-full  flex flex-col gap-4 text-left md:px-6 px-4">
            <h2
              className="text-lg font-semibold"
              dangerouslySetInnerHTML={{
                __html: featuresTitle || `What's included?`,
              }}
            ></h2>
            <div className="flex flex-col gap-3">
              {features.map((feature, index) => {
                return (
                  <div
                    key={index}
                    className="flex items-start justify-start gap-2"
                  >
                    <div className=" w-6 h-6  flex items-center justify-center shrink-0">
                      {featuresIcon}
                    </div>
                    <p
                      className={`text-base leading-[24px] font-medium hover:bg-gradient-to-r   ${
                        feature?.image
                          ? " underline underline-offset-[5px] decoration-dotted cursor-pointer decoration-gray-400 hover:decoration-primary hover:text-primary hover:from-purple-500  hover:via-indigo-500  hover:to-blue-500  hover:bg-clip-text  hover:text-transparent "
                          : ""
                      }`}
                      onClick={() =>
                        feature?.image && setImagePopup(feature.image)
                      }
                    >
                      {feature?.name}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="w-full md:px-6 px-4 md:pb-6 pb-4">
          {buttonText && (
            <CLMButtonPrimary1
              buttonText={price == 0 ? "Get Started" : buttonText}
              onClick={() =>
                title === "Enterprise"
                  ? setShowCalcomModal(true)
                  : buttonUrl
                  ? window.open(buttonUrl, "_self")
                  : createStripeSubscription(title)
              }
              className="w-full "
            />
          )}
          {title === "Enterprise" && (
            <CLMButtonSecondaryBorder
              buttonText={"Contact Us"}
              buttonUrl={"tel:+14156496611"}
              className="w-full mt-2"
            />
          )}
          {buttonSecondaryText && (
            <>
              <CLMSecondaryBorder
                buttonText={buttonSecondaryText}
                buttonUrl={`${pricingLink}`}
              />
            </>
          )}
          {trialButtonText && price !== 0 && title !== "Enterprise" && (
            <div className="mt-2">
              {is1DollarTrialCampaignState ? (
                <CLMSecondaryBorder
                  btnText={"Start 7-days trial @1$"}
                  className="w-full"
                />
              ) : (
                <CLMSecondaryBorder
                  buttonText={trialButtonText}
                  className="w-full"
                  onClick={() => {
                    conditions?.navigateRegister
                      ? window.open(trialButtonUrl, "_self")
                      : setRegisterPopup(true);
                  }}
                />
              )}
            </div>
          )}
          {!is1DollarTrialCampaignState && noCreditCard && (
            <p
              className={`text-center text-sm text-gray-600 mt-2  ${
                title === "Enterprise" && "overflow-hidden w-0 h-[20px]"
              }`}
            >
              No credit card required
            </p>
          )}

          {contactUs && (
            <CLMButtonSecondaryBorder
              buttonText={"Contact Us"}
              buttonUrl={"https://cal.com/boloforms/signature"}
              className="w-full"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PricingCardV3;
